import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

//components
import {
  Button,
  CurveHolder,
  Span,
  StyledText,
} from "../../../components/common/basic";
import {
  ConfirmIcon,
  Curve,
  CurveUp,
  DoneBackground,
  DoneIconNew,
  NewBackButton,
  VoteIcon,
} from "../../../components/svgs";

// hooks
import { useTheme, useLoyalty } from "../../../hooks";

const MovieDescription = () => {
  const { themeContext, theme } = useTheme();
  const {
    selectedMovie,
    submitVote,
    voted,
    getMovieList,
    setVotingEnd,
    votingEnd,
  } = useLoyalty();

  let history = useHistory();

  const [confirmVote, setConfirmVote] = useState(false);
  const [votingComplete, setVotingComplete] = useState(false);

  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  useEffect(() => {
    getMovieList();
  }, [confirmVote]);

  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "MovieDescription",
        firebase_screen_class: "MovieDescription",
      })
    );
  }, []);
  return (
    <>
      <MainHolder activeTheme={mashupBackground}>
        <Children>
          <BackButtonContainer
            onClick={() => {
              history.goBack();
            }}
          >
            <NewBackButton />
          </BackButtonContainer>
          <Header>
            <Image src={selectedMovie?.imageUrl} />
            <Gradient>
              <GradientBody>
                <StyledText
                  color={"white"}
                  style={{
                    marginBlockStart: 0,
                    marginBlockEnd: 0,
                    padding: 2,
                    textAlign: "start",
                    width: "90%",
                  }}
                  size={22}
                >
                  {selectedMovie?.title}
                </StyledText>
                <StyledText
                  color={"white"}
                  style={{
                    marginBlockStart: 0,
                    marginBlockEnd: 0,
                    padding: 2,
                    textAlign: "start",
                    fontFamily: "MTNLight",
                    width: "90%",
                  }}
                  size={14}
                >
                  {selectedMovie?.genre + "·" + selectedMovie?.duration}
                </StyledText>
              </GradientBody>
            </Gradient>
          </Header>
          <DescriptionBody color={mashupBackground}>
            {!confirmVote ? (
              <>
                <CurveHolder>
                  <Curve fill={mashupBackground} />
                </CurveHolder>
                <DescriptionContentHeader>
                  <StyledText
                    color={background}
                    style={{
                      marginBlockStart: 0,
                      marginBlockEnd: 0,
                      padding: 2,
                      textAlign: "center",
                      width: "100%",
                    }}
                    size={22}
                  >
                    {selectedMovie?.votes}
                  </StyledText>
                  <StyledText
                    color={"black"}
                    style={{
                      marginBlockStart: 0,
                      marginBlockEnd: 0,
                      padding: 2,
                      textAlign: "center",
                      width: "100%",
                    }}
                    size={18}
                  >
                    {"Number of votes"}
                  </StyledText>
                  <StyledText
                    color={"black"}
                    style={{
                      marginBlockStart: 0,
                      marginBlockEnd: 0,
                      padding: 2,
                      textAlign: "center",
                      width: "95%",
                      fontFamily: "MTNLight",
                    }}
                    size={12}
                  >
                    {!voted ? (
                      "Vote now to stand a chance to watch this movie for free"
                    ) : (
                      <>
                        <VoteIcon voted={voted} />
                        {` You have voted`}
                      </>
                    )}
                  </StyledText>
                  <Divider />
                  <StyledText
                    color={"black"}
                    style={{
                      marginBlockStart: 0,
                      marginBlockEnd: 0,
                      padding: 2,
                      textAlign: "start",
                      width: "100%",
                      fontFamily: "MTNMedium",
                    }}
                    size={20}
                  >
                    {"Description"}
                  </StyledText>
                  <StyledText
                    color={"black"}
                    style={{
                      marginBlockStart: 0,
                      marginBlockEnd: 0,
                      padding: 2,
                      textAlign: "start",
                      width: "100%",
                      fontFamily: "MTNRegular",
                    }}
                    size={12}
                  >
                    {selectedMovie?.description}
                  </StyledText>
                  <Button
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginInline: 15,
                      marginTop: 35,
                    }}
                    disabled={voted}
                    color={background}
                    onClick={(e) => {
                      e.preventDefault();
                      if (!voted) {
                        setConfirmVote(true);
                      }
                    }}
                  >
                    <StyledText style={{ marginRight: 10 }} color={"white"}>
                      Vote
                    </StyledText>
                  </Button>
                </DescriptionContentHeader>
              </>
            ) : (
              <>
                <CurveHolder>
                  <CurveUp width={420} height={80} fill={mashupBackground} />
                </CurveHolder>
                {!votingComplete ? (
                  <>
                    <DescriptionContentHeader>
                      <IconHolder>
                        <DoneBackground
                          fill={background}
                          style={{ position: "absolute", zIndex: 2 }}
                        />
                        <ConfirmIcon
                          style={{ position: "absolute", zIndex: 2 }}
                        />
                      </IconHolder>
                      <StyledText
                        style={{
                          marginBlockStart: 0,
                          marginBlockEnd: 0,
                          padding: 2,
                          textAlign: "center",
                          width: "100%",
                          fontFamily: "MTNRegular",
                          marginTop: 75,
                        }}
                        size={22}
                      >
                        {"Confirm Vote"}
                      </StyledText>
                      <StyledText
                        style={{
                          marginBlockStart: 0,
                          marginBlockEnd: 0,
                          padding: 2,
                          textAlign: "center",
                          width: "100%",
                          fontFamily: "MTNRegular",
                          marginTop: 75,
                        }}
                        size={12}
                      >
                        {"Do you want to vote for "}
                        <Span
                          style={{
                            marginBlockStart: 0,
                            marginBlockEnd: 0,
                            padding: 2,
                            textAlign: "center",
                            width: "100%",
                            fontFamily: "MTNMedium",
                            marginTop: 75,
                          }}
                          size={12}
                        >
                          {selectedMovie?.title}
                        </Span>
                        {
                          " to be shown at the cinema. You can view the leaderboard to check the current ranking for this movie."
                        }
                      </StyledText>
                      <ButtonHolder>
                        <Button
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginInline: 15,
                            marginTop: 35,
                            width: "40%",
                            borderColor: background,
                            borderWidth: 1,
                            border: `solid ${background}`,
                          }}
                          color={mashupBackground}
                          onClick={(e) => {
                            e.preventDefault();
                            setConfirmVote(false);
                          }}
                        >
                          <StyledText
                            style={{ marginRight: 10 }}
                            color={background}
                          >
                            Cancel
                          </StyledText>
                        </Button>
                        <Button
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginInline: 15,
                            marginTop: 35,
                            width: "40%",
                          }}
                          color={background}
                          onClick={(e) => {
                            e.preventDefault();
                            setVotingComplete(true);
                            submitVote(selectedMovie?._id);
                          }}
                        >
                          <StyledText
                            style={{ marginRight: 10 }}
                            color={"white"}
                          >
                            Confirm
                          </StyledText>
                        </Button>
                      </ButtonHolder>
                    </DescriptionContentHeader>
                  </>
                ) : (
                  <>
                    <DescriptionContentHeader>
                      <IconHolder>
                        <DoneBackground
                          fill={background}
                          style={{ position: "absolute", zIndex: 2 }}
                        />
                        <DoneIconNew
                          style={{ position: "absolute", zIndex: 2 }}
                        />
                      </IconHolder>
                      <StyledText
                        style={{
                          marginBlockStart: 0,
                          marginBlockEnd: 0,
                          padding: 2,
                          textAlign: "center",
                          width: "100%",
                          fontFamily: "MTNRegular",
                          marginTop: 75,
                        }}
                        size={22}
                      >
                        {"Voting Complete"}
                      </StyledText>
                      <StyledText
                        style={{
                          marginBlockStart: 0,
                          marginBlockEnd: 0,
                          padding: 2,
                          textAlign: "center",
                          width: "100%",
                          fontFamily: "MTNRegular",
                          marginTop: 75,
                        }}
                        size={12}
                      >
                        {"You have voted for "}
                        <Span
                          style={{
                            marginBlockStart: 0,
                            marginBlockEnd: 0,
                            padding: 2,
                            textAlign: "center",
                            width: "100%",
                            fontFamily: "MTNMedium",
                            marginTop: 75,
                          }}
                          size={12}
                        >
                          {selectedMovie?.title}
                        </Span>
                        {
                          " to be shown at the cinema. You can view the leaderboard to check the current ranking for this movie."
                        }
                      </StyledText>
                      <ButtonHolder>
                        <Button
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginInline: 15,
                            marginTop: 35,
                            width: "90%",
                          }}
                          color={background}
                          onClick={(e) => {
                            e.preventDefault();
                            setConfirmVote(false);
                            setVotingComplete(false);
                            // setVotingEnd(true);
                            const token = JSON.parse(
                              localStorage.getItem("token")
                            );
                            history.push(`/home?token=${token}`);
                          }}
                        >
                          <StyledText
                            style={{ marginRight: 10 }}
                            color={"white"}
                          >
                            Great
                          </StyledText>
                        </Button>
                      </ButtonHolder>
                    </DescriptionContentHeader>
                  </>
                )}
              </>
            )}
          </DescriptionBody>
        </Children>
      </MainHolder>
    </>
  );
};

const MainHolder = styled.div`
  display: grid;
  align-content: space-between;
  grid-template-rows: auto auto 1fr;
  overflow: hidden;
  scrollbar-width: none;
  background-color: ${({ activeTheme }) => activeTheme};
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  margin: 8px;
  z-index: 5;
`;

const Header = styled.div`
  width: 100%;
  height: 300px;
  overflow: hidden;
  position: relative;
  padding: 20;
`;

const Image = styled.img`
  width: 100%;
  height: 360px;
  position: absolute;
`;

const Gradient = styled.div`
  width: 100%;
  height: 300px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.17) 39.58%,
    #000000 100%
  );
  position: absolute;
  z-index: 1;
  display: grid;
  grid-auto-flow: column;
  align-items: flex-start;
`;

const GradientBody = styled.div`
  padding: 5px;
  display: flex;
  flex-direction: column;
  height: 80%;
  justify-content: flex-end;
`;

const DescriptionBody = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${({ color }) => color};
  align-items: center;
  position: relative;
  z-index: 1;
`;

const DescriptionContentHeader = styled.div`
  padding: 10px;
  width: 95%;
`;

const Divider = styled.div`
  width: 100%;
  align-self: center;
  background-color: #c4c4c4;
  height: 1px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const IconHolder = styled.div`
  display: flex;
  width: 100%;
  margin-top: -55px;
  position: relative;
  align-items: center;
  justify-content: center;
`;

const ButtonHolder = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
`;

export default MovieDescription;
